export const STATUS2COLOR = new Map([
  [0, 'gray'],
  [1, 'blue'],
  [2, 'green'],
  [3, 'red'],
]);
